import { type ReactElement } from 'react'
import { cn } from '@util'
import { Skeleton, Stack, Text } from '@mantine/core'
import { SizePrimitives } from '@front/model'

export type SkeletonSection = {
  label: string
  rowCount: number
}

type Props = {
  isCollapsed: boolean
  sections: SkeletonSection[]
}

const buildRowKeys = (label: string, rowCount: number): string[] =>
  Array.from({ length: rowCount }, (_, index) => `${label}-${index}`)

export const NavigationSkeleton = ({ isCollapsed, sections }: Props): ReactElement => {
  return (
    <Stack gap={isCollapsed ? 'xs' : 'md'}>
      {sections.map((section) => (
        <Stack gap='xs' key={section.label}>
          {!isCollapsed && (
            <Text size='xs' className={cn('px-2 font-medium tracking-[0.18em] uppercase')} c='dimmed'>
              {section.label}
            </Text>
          )}
          {buildRowKeys(section.label, section.rowCount).map((rowKey) => (
            <Skeleton h={SizePrimitives['9']} key={rowKey} w={isCollapsed ? SizePrimitives['9'] : '100%'} />
          ))}
        </Stack>
      ))}
    </Stack>
  )
}
